const footerLinks = [
  { href: "#overview", label: "本站导览" },
  { href: "#styles", label: "画风图鉴" },
  { href: "#works", label: "作品合集" },
  { href: "#characters", label: "人物关系" },
  { href: "#guide", label: "阅读指南" },
  { href: "#community", label: "同人术语" },
  { href: "#faq", label: "常见问答" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 px-4 md:px-8 pt-14 md:pt-16 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                女友的妈妈
              </span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed max-w-md">
              一个专注整理“女友的妈妈”题材同人漫画、插画与本子合集的中文导览站。
              我们按画风与剧情设定为作品归类，帮助你用更短的时间找到想看的方向。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-50/25 text-background-200/90 text-xs">
              <i className="ri-shield-check-line"></i>
              内容导览仅供成年读者参考
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-base font-bold text-background-50">
              <a href="#top" className="hover:text-accent-300 transition-colors">
                页面导航
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 lg:grid-cols-1 gap-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/80 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-heading text-base font-bold text-background-50">
              <a href="#faq" className="hover:text-accent-300 transition-colors">
                关于内容
              </a>
            </h4>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed">
              本站条目中的作品名称、作者与简介为示意内容，用于呈现分类与筛选效果，
              并非已核实的发行信息。请以对应发布方的信息为准，理性看待同人创作与二次表达。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © 2026 女友的妈妈 · 同人漫画与插画导览站
          </p>
          <p className="text-xs text-background-200/70">
            本站为同人创作导览索引，不提供任何作品下载或传播服务
          </p>
        </div>
      </div>
    </footer>
  );
}